import React from 'react';
import { NavigationScreenProps } from 'screens/navigation';
import MedicationDetailsSummary from './MedicationDetailsSummary';

export default function PastMedicationDetailsSummary(props: NavigationScreenProps) {
  return <MedicationDetailsSummary {...props} medicationType="Past" />;
}
